module.exports = __webpack_public_path__ + "static/media/selectDropdown.2ac8e029.svg";